<template>
  <div id="app">
    <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
      <header class="mdl-layout__header">
        <div class="mdl-layout__header-row">
          <!-- Title -->
          <!-- <span class="mdl-layout-title"> -->
          <a href="/">
            <img class="mdl-layout-title" src="./assets/logo-text.png" alt="Mundle logo">
          </a>
          <!-- </span> -->

          <!-- Add spacer, to align navigation to the right -->
          <div class="mdl-layout-spacer"></div>
          <div class="mdl-textfield mdl-js-textfield mdl-textfield--expandable" id="search-container">
            <label class="mdl-button mdl-js-button mdl-button--icon" for="search">
              <i class="material-icons">search</i>
            </label>
            <div class="mdl-textfield__expandable-holder">
              <input class="mdl-textfield__input" type="text" id="search" v-on:keyup.enter="search">
              <label class="mdl-textfield__label" for="name">Search</label>
            </div>
          </div>

          <!-- Navigation. We hide it in small screens. -->
          <nav class="mdl-navigation">
            <div class="dropdown" v-if="isUserLoggedIn === false">
              <a class="mdl-navigation__link dropdown-btn" href="/sign-in">
                <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--accent">
                  Sign In
                </button>
              </a>
            </div>
            <div class="dropdown" v-if="isUserLoggedIn === true">
              <a class="mdl-navigation__link dropdown-btn">
                <img v-if="photoURL" v-bind:src="photoURL" v-bind:alt="displayName">
                <img v-if="!photoURL" src="./assets/profile.svg" alt="Profile picture">
              </a>
              <div class="dropdown-content">
                <a v-if="teacherVerified" href="/upload" class="accent">Upload Material</a>
                <button class="mdl-button mdl-js-button mdl-button--accent mdl-button--raised" v-on:click="logOut">
                  Sign out
                </button>
              </div>
            </div>

          </nav>
        </div>
      </header>
      <div class="mdl-layout__drawer" id="drawer">
        <span class="mdl-layout-title">Hello <strong class="accent">{{ displayName }}</strong></span>
        <nav class="mdl-navigation">
          <div class="nav-section">
            <h4>Explore</h4>
            <a href="/notes" class="mdl-navigation__link">
              <button class="nav-buttons">Class Notes</button>
            </a>
            <a href="/audio-notes" class="mdl-navigation__link">
              <button class="nav-buttons">Audio Notes</button>
            </a>
            <a href="/past-questions-and-answers" class="mdl-navigation__link">
              <button class="nav-buttons">Past Questions and Answers</button>
            </a>
          </div>
          <div class="nav-section">
            <h4>Profile</h4>
            <a href="/library" class="mdl-navigation__link">
              <button class="nav-buttons">Library</button>
            </a>
            <a href="/settings" class="mdl-navigation__link">
              <button class="nav-buttons">Settings</button>
            </a>
          </div>
        </nav>
      </div>
      <main class="mdl-layout__content">
        <div class="page-content">
          <router-view/>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'app',
  data () {
    return {
      title: 'MUNDLE',
      isUserLoggedIn: false,
      displayName: '',
      photoURL: '',
      teacherVerified: false
    }
  },
  created () {
    let db = firebase.database()

    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        this.isUserLoggedIn = true
        db.ref('users/' + user.uid).on('value', (snapshot) => {
          this.displayName = snapshot.val().fullname
          this.photoURL = snapshot.val().photoURL
          this.teacherVerified = snapshot.val().teacherVerified
        })
      }
    }.bind(this))
  },
  methods: {
    logOut: function () {
      firebase.auth().signOut().then(() => {
        window.location.reload()
      }).catch((err) => {
        alert(err)
      })
    },
    search: function () {
      let param = document.querySelector('#search').value
      let path = '/search/' + param
      this.$router.push({path: path})
    }
  }
}
</script>

<style>
#app {
  font-family: 'Roboto', sans-serif;
  text-rendering: optimizeSpeed;
  line-height: 24px;
  font-size: 16px;
}
.accent {
  color: #ff4081;
}
p {
  font-family: 'Roboto', sans-serif;
  line-height: 24px;
  font-size: 16px;
}
.mdl-layout__header-row {
  background-color: white;
}
.mdl-button--accent, .mdl-button--primary {
	border-radius: 18px;
}
img {
  width: 60px;
  height: 60px;
}
.nav-section h4 {
  color: #424242;
  font-size: 18px;
  margin-bottom: 0;
  margin-top: 16px;
  padding: 0 0 0 16px;
}
.mdl-layout__drawer .mdl-navigation .mdl-navigation__link {
  padding: 8px;
}
.mdl-navigation__link img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #eee;
}
.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown-content {
    position: absolute;
    top: 56px;
    right: 0;
    display: none;
    padding: 5px;
    background-color: #fafafa;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
    text-align: center;
}
.dropdown-content a:link {
  padding: 5px;
  margin-bottom: 10px;
  text-decoration: none;
  font-size: 14px;
}
.dropdown-content a:hover {
  background-color: #eee;
}
.dropdown:hover .dropdown-content {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: auto;
  -moz-transition: -moz-transform 5.4s ease-out;
  -webkit-transition: -webkit-transform 5.4s ease-out;
  transition: transform 5.4s ease-out;
}
.nav-buttons {
  color: #101010;
  border: none;
  text-decoration: none;
  outline: none;
  background: none;
}
.mdl-button {
  font-weight: normal;
  font-size: 14px;
}
.mdl-button--accent.mdl-button--accent.mdl-button--raised {
  background-color: #ff4081;
  color: black;
}
h1, h2, h3, h4, h5, h6 {
  font-family: 'Katibeh';
}
h1, h2 {
  font-size: 44px;
}
h3, h4 {
  font-size: 30px;
}
h5, h6 {
  font-size: 24px;
}
.fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/App.vue